<template>
	<vx-card no-shadow card-border :title="title" :subtitle="subtitle">
		<vs-divider />
		<vue-perfect-scrollbar :style="scrollArea" :settings="settings">
			<!-- RESOURCE LIST -->
			<div id="card-resource-list">
				<ul class="bordered-items">
					<li class="cursor-pointer" v-for="resource in resourcesDataFilter" :key="resource.uid">
						<massive-assignment-resume-resource-list-item
							:resource="resource"
							:isActiveChatUser="isActiveChatUser"
						></massive-assignment-resume-resource-list-item>
					</li>
				</ul>
			</div>
		</vue-perfect-scrollbar>
	</vx-card>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

import NotPermission from "@/views/pages/NotPermission.vue";
import moduleResource from "@/store/resource/moduleResource.js";

import User from "@/models/User.js";
import MassiveAssignmentResumeResourceListItem from "./MassiveAssignmentResumeResourceListItem.vue";

export default {
	components: {
		VuePerfectScrollbar,
		NotPermission,
		MassiveAssignmentResumeResourceListItem,
		vSelect,
	},
	props: {
		title: {type: String, default: ""},
		subtitle: {type: String, default: ""},
		isActiveChatUser: {type: Boolean, default: true},

		multiple: false,
		scrollArea: {
			type: Object,
			default: () => {
				return {
					margin: " auto",
					width: " 100%",
					"min-height": "  475px",
					"max-height": "  475px",
				};
			},
		},
	},
	data() {
		return {
			activeItem: "",
			activeAlert: true,
			searchQuery: null,
			userSession: new User(),
			currentSelectResource: null,
			active: true,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.7,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 100,

			checkedAll: false,
			searchField: "Name",
			// Style loading
			backgroundLoading: "#FFFFFF",
			colorLoading: "primary",
			visit_point_ids: [],
		};
	},
	computed: {
		getCheckedResources() {
			return this.$store.state.moduleResource.checkedResources;
		},
		resources() {
			return this.$store.state.moduleResource.resources; //.map(resource => ({...resource, selected : false}));
		},
		resourcesDataFilter() {
			const data = this.getCheckedResources;
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return data;
			}
			return data;
		},
	},
	methods: {
		openLoadingContained() {
			this.$vs.loading({
				background: this.backgroundLoading,
				color: this.colorLoading,
				container: "#card-resource-list",
				scale: 1,
			});
		},
		closeLoadingContained() {
			this.$vs.loading.close("#card-resource-list > .con-vs-loading");
		},

		updateActiveChatUser(resource) {
			this.currentSelectResource = resource;
			this.visit_point_ids = this.currentSelectResource.visit_point_id || [];
			if (this.visit_point_ids.length > 0) this.getVisitPoint();
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
	mounted() {
		if (this.$store.state.moduleResource.resources.length <= 0) {
		}
	},
	beforeDestroy() {
		this.$store.commit("moduleResource/CLEAR_RESOURCES");
	},
	beforeCreate() {
		this.$store.commit("moduleResource/CLEAR_RESOURCES");
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 475px;
	max-height: 475px;
}

.scroll-area--sidebard-height {
	margin: auto;
	width: 100%;
	min-height: 100%;
	max-height: 100%;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
	background: chocolate;
}

.slide-fade-enter,
.slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
</style>
